<template>
    <b-card header-class="bar-color1">
        <template v-slot:header>
            <slot>{{ $t('patient.dataLabel') }} / {{ patient.code | valueOrEmpty }}</slot>
        </template>

        <div class="row no-gutters">
            <div class="col-0 ml-3 mb-md-3 col-md-1" >
                <div class="d-none d-md-inline-block">
                    <img class="patient-image" v-if="patient.sex === 'male'" src="@/assets/user_male.svg" alt="">
                    <img class="patient-image" v-else src="@/assets/user_female.svg" alt="">
                </div>
            </div>

            <div class="col-12 ml-3 mb-3 col-md-5 col-lg-4" >

                <display-field
                    :field="patientFields.code"
                    :label-class="labelClass"
                    :value="patient.code"
                    :value-class="valueClass"
                />
                <display-choice-field
                    :field="patientFields.sex"
                    :label-class="labelClass"
                    :value="patient.sex"
                    :value-class="valueClass"
                />
                <display-field :field="patientFields.birthday" :label-class="labelClass">
                    <span :class="valueClass">{{ patient.birthday | date({showDay: false}) }}</span>
                </display-field>

                <div
                    class="form-value"
                    :class="{'text-success': patient.is_study_consent,
                    'text-danger': !patient.is_study_consent}"
                >
                    <i class="fas" :class="{'fa-check': patient.is_study_consent,
                    'fa-times mr-1': !patient.is_study_consent}"></i>
                    {{ patientFields.is_study_consent.label }}
                </div>

                <div
                    class="form-value"
                    :class="{'text-success': patient.is_genetic_study_consent,
                    'text-danger': !patient.is_genetic_study_consent}"
                >
                    <i class="fas" :class="{'fa-check': patient.is_genetic_study_consent,
                    'fa-times mr-1': !patient.is_genetic_study_consent}"></i>
                    {{ patientFields.is_genetic_study_consent.label }}
                </div>

                <div v-if="patient.exitus" class="">
                    <div><i class="fas fa-cross mr-2"></i>{{ $t('patient.exitus') }}</div>
                </div>
            </div>
            <div class="col-12 ml-3 mb-3 col-md-5">
                <display-choice-field
                    :field="patientFields.hemophilia_type"
                    :label-class="labelClass"
                    :value="patient.hemophilia_type"
                    :value-class="valueClass"
                />
                <display-field
                    :field="patientFields.iti_year_eradication"
                    :label-class="labelClass"
                    no-help-text
                >
                    <span class="form-value">{{ patient.iti_year_eradication }}</span>
                </display-field>
                <display-field
                    :field="patientFields.has_family_history_inhibitors"
                    :label-class="labelClass"
                >
                    <span class="form-value">
                        {{ patient.has_family_history_inhibitors | yesno | capitalize  }}
                    </span>
                </display-field>
                <display-array-field
                    :field="patientFields.usual_treatment"
                    :values="patient.usual_treatment"
                    choices
                />
                <display-choice-field
                    :field="patientFields.infusion_number"
                    :label-class="labelClass"
                    :value="patient.infusion_number"
                    :value-class="valueClass"
                />
                <display-choice-field
                    :field="patientFields.on_demand_treatment"
                    :label-class="labelClass"
                    :value="patient.on_demand_treatment"
                    :value-class="valueClass"
                />
                <display-field
                    :field="patientFields.on_demand_treatment_prophylaxis"
                    :label-class="labelClass"
                    :value="patient.on_demand_treatment_prophylaxis"
                    :value-class="valueClass"
                />
                <display-array-field
                    :field="patientFields.mutations"
                    :values="patient.mutations"
                    no-help-text
                />
                <display-field
                    :field="patientFields.relevant_comorbidities"
                    :label-class="labelClass"
                    :value="patient.relevant_comorbidities"
                    :value-class="valueClass"
                />
            </div>
        </div>

        <slot name="after-data"></slot>
    </b-card>
</template>

<script>
    import {mapState} from "vuex";
    import ShowFieldsMixin from "@/components/mixins/ShowFieldsMixin";
    import DisplayField from "@/components/DisplayField";
    import DisplayArrayField from "@/components/DisplayArrayField";
    import DisplayChoiceField from "@/components/DisplayChoiceField";

    export default {
        name: "PatientData",
        components: {DisplayChoiceField, DisplayArrayField, DisplayField},
        mixins: [ShowFieldsMixin],
        computed: {
            ...mapState(['currentUser', 'patient', 'patientFields']),
            showImage() {
                return this.patient !== null && !this.creating;
            },
            cols() {
                return 12;
            },
            mdCols() {
                return 6;
            },
            labelClass() {
                return 'form-label';
            },
            valueClass() {
                return 'form-value';
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import "src/custom";

    .patient-image {
        height: auto;
        width: 100%;
        max-width: 110px;
    }

    .header-code {
        color: $secondary;
    }
</style>